import { useNavigate } from "react-router";
import { usePortalReviewScenarios } from "@shared-core/data/PortalSignInAdapterContext";
import { outcomePath } from "./outcomePath";

/**
 * Review tool: jump between the states the sign-in can land on. Stands in for signing in as
 * different people, which the mock build cannot do. Rendered only where review scenarios are
 * mounted (the mock build), never in the real portal.
 */
export function PortalReviewBar({ current }: { current?: string }) {
  const review = usePortalReviewScenarios();
  const navigate = useNavigate();
  if (!review) return null;
  const scenarios = review.listScenarios();
  return (
    <div className="border-t bg-card px-4 py-2 text-xs text-muted-foreground">
      <label className="mx-auto flex max-w-md flex-wrap items-center gap-2">
        <span className="font-medium text-foreground">Review tool</span>
        <span>Sign-in state:</span>
        <select
          className="min-w-0 flex-1 rounded-md border bg-background px-2 py-1 text-foreground"
          value={current ?? ""}
          onChange={(e) => {
            const scenario = scenarios.find((s) => s.id === e.target.value);
            if (!scenario) return;
            review.selectScenario(scenario.id);
            navigate(outcomePath(scenario.outcome, scenario.id));
          }}
        >
          <option value="" disabled>
            Choose a state…
          </option>
          {scenarios.map((s) => (
            <option key={s.id} value={s.id}>
              {s.label}
            </option>
          ))}
        </select>
      </label>
    </div>
  );
}
